import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8.769",
  height: "4.385"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#022b36",
  d: "m0 0 4.385 4.385L8.77 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };